import React from 'react'

export const MONTHS = [
  {
    id: 1,
    name: 'Jan'
  },
  {
    id: 2,
    name: 'Feb'
  },
  {
    id: 3,
    name: 'Mär'
  },
  {
    id: 4,
    name: 'Apr'
  },
  {
    id: 5,
    name: 'Mai'
  },
  {
    id: 6,
    name: 'Jun'
  },
  {
    id: 7,
    name: 'Jul'
  },
  {
    id: 8,
    name: 'Aug'
  },
  {
    id: 9,
    name: 'Sep'
  },
  {
    id: 10,
    name: 'Okt'
  },
  {
    id: 11,
    name: 'Nov'
  },
  {
    id: 12,
    name: 'Dez'
  }
]

export default function MonthFilter({
  width = 335,
  currentFile,
  setEnabledMonths,
  enabledMonths
}) {
  const handleClick = month => {
    setEnabledMonths(enabled => enabled.filter(m => false).concat(month)
    )
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        maxWidth: 600,
        margin: 'auto',
        pointerEvents: 'all',
        cursor: 'pointer'
      }}
    >
      {MONTHS.map(m => (
        <div
          key={m.id}
          style={{
            fontSize: '0.7rem',
            textTransform: 'uppercase',
            lineHeight: 1.4,
            textAlign: 'center',
            color:
              currentFile && currentFile.month === m.id
                ? '#fff'
                : enabledMonths.includes(m.id)
                ? '#666'
                : '#666',
            // borderBottom: enabledMonths.includes(m.id) ? '3px solid #666' : undefined,
            fontWeight: 800
          }}
          onClick={() => handleClick(m.id)}
        >
          {m.name}
          <br />
          <img src={enabledMonths.includes(m.id) ? 'minus.svg' : 'plus.svg'} />
        </div>
      ))}
    </div>
  )
}
